import React from 'react';
import { ChartDimensions } from '../../types';

interface TitleConfig {
  text: string;
  color?: string;
  fontSize?: number;
  fontWeight?: string | number;
  fontFamily?: string;
  align?: 'start' | 'center' | 'end';
  padding?: number;
}

interface TitleProps {
  config: string | TitleConfig | undefined;
  dimensions: ChartDimensions;
  defaultColor?: string;
  defaultFontFamily?: string;
}

/**
 * Title component - Renders chart title
 */
export const Title: React.FC<TitleProps> = ({
  config,
  dimensions,
  defaultColor = '#333',
  defaultFontFamily,
}) => {
  if (!config) return null;

  const { chartWidth, padding } = dimensions;

  // Normalize config
  const titleConfig: TitleConfig = typeof config === 'string' 
    ? { text: config }
    : config;

  const {
    text,
    color = defaultColor,
    fontSize = 16,
    fontWeight = 'bold',
    fontFamily = defaultFontFamily,
    align = 'center',
    padding: titlePadding = 10,
  } = titleConfig;

  if (!text) return null;

  // Calculate x position based on alignment
  let x: number;
  let textAnchor: 'start' | 'middle' | 'end';

  switch (align) {
    case 'start':
      x = 0;
      textAnchor = 'start';
      break;
    case 'end':
      x = chartWidth;
      textAnchor = 'end';
      break;
    case 'center':
    default:
      x = chartWidth / 2;
      textAnchor = 'middle';
  }

  return (
    <text
      x={x}
      y={-padding.top + titlePadding + fontSize}
      textAnchor={textAnchor}
      fill={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      fontFamily={fontFamily}
      className="chart-title"
    >
      {text}
    </text>
  );
};

export default Title;

